<script>
    import {
        Badge
    } from "sveltestrap";

    import { _ } from 'svelte-i18n';
    
    import { useQuery } from '@sveltestack/svelte-query';
    const profilData = useQuery("profilData");
</script>

{#if $profilData.data.interests}
    <br />
    {#each $profilData.data.interests as interest}
        <Badge class="mr-1">{interest.name}</Badge>
    {/each}
{:else}
    <p class="text-muted">
        Aucun intérêt n'a été renseigné
    </p>
{/if}